/** @format */

import React from 'react';

const ModalBody = props => {
    return <div className={('modal-body ' + props.className).trim()}>{props.children}</div>;
};

const ModalHeader = props => {
    return <div className="modal-header">{props.children}</div>;
};

const ModalFooter = props => {
    return <div className="modal-footer">{props.children}</div>;
};

const ModalFooterSticky = props => {
    return <div className="modal-footer modal-footer--sticky">{props.children}</div>;
};

const ModalClose = props => {
    return (
        <button
            tabIndex="-2"
            type="button"
            className="close bg-white tw-flex tw-items-center tw-justify-center"
            onClick={props.onClose}
            aria-label="Close">
            <span aria-hidden="true">
                <i className="fa fa-close" />
            </span>
        </button>
    );
};

/**
 * A component for making modals. As if you didn't already know
 * Don't use this one anymore. Use the portal version
 * <Modal>
 *  <ModalHeader>Some Head</ModalHeader>
 *  <ModalBody>All the nice body</ModalBody>
 *  <ModalFooter>Some Footer</ModalFooter>
 * </Modal>
 */
class Modal extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (this.props.allowOverflow) return;

        document.body.style.height = '100%';
        document.body.style.overflow = 'hidden';
    }

    componentWillUnmount() {
        document.body.style.height = 'auto';
        document.body.style.overflow = 'auto';
    }

    render() {
        if (this.props.pending) {
            return (
                <div className="modal-open">
                    <div
                        className="modal d-block modal-above-cart"
                        role="dialog"
                        style={{zIndex: 10500}}>
                        <div
                            style={{...this.props.modalDialogStyle, zIndex: 10500}}
                            className={
                                'modal-dialog modal-dialog-above-cart ' +
                                this.props.modalDialogClass
                            }
                            role="document">
                            <div className="modal-content">
                                <div className="modal-body">Loading...</div>
                            </div>
                            <a
                                tabIndex="-2"
                                onClick={this.props.onClose}
                                className="btn"
                                style={{zIndex: 10501}}>
                                <i className="fa fa-remove" />
                            </a>
                        </div>
                        <div
                            onClick={this.props.onClose}
                            className="modal-backdrop modal-backdrop-above-cart"
                            style={{zIndex: 10499}}
                        />
                    </div>
                </div>
            );
        } else if (this.props.bdOnly && !this.props.pending) {
            return (
                <>
                    {this.props.children}
                    <div onClick={this.props.onClose} className="modal-backdrop" />
                </>
            );
        } else if (!this.props.pending && !this.props.bdOnly) {
            return (
                <div className="modal-open">
                    <div
                        className="modal d-block modal-above-cart"
                        role="dialog"
                        style={{zIndex: 10500}}>
                        <div
                            style={{...this.props.modalDialogStyle, zIndex: 10500}}
                            className={
                                'modal-dialog modal-dialog-above-cart ' +
                                this.props.modalDialogClass
                            }
                            role="document">
                            <div className="modal-content">{this.props.children}</div>
                        </div>
                        <div
                            onClick={this.props.onClose}
                            className="modal-backdrop modal-backdrop-above-cart"
                            style={{zIndex: 10499}}
                        />
                    </div>
                </div>
            );
        }
    }
}

Modal.defaultProps = {
    modalDialogClass: 'modal-lg',
    modalDialogStyle: {},
    onClose: () => {}
};

export default Modal;

export {ModalBody, ModalHeader, ModalFooter, ModalFooterSticky, ModalClose};
